/**
 * Custom methods
 * -----------------------------------------------------------------------------
 *
 * @namespace custom
 */

// media queries in Javascript => http://wicky.nillia.ms/enquire.js/
import enquire from 'enquire.js';
// detect if a device is mouseOnly, touchOnly, or hybrid => http://detect-it.rafrex.com/
import detectIt from 'detect-it';
import axios from 'axios';
import Flickity from 'flickity';

var customMethods = {
  data: function data() {
    return {
      // your data here
      page: [],
      isLoadingMethods: '',
      isYaleProFormValid: true,
      yaleProformStatus: '',
      yaleFormData: {
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        business_type: '',
        billing_address: '',
        address_line_2: '',
        city: '',
        state: '',
        zipcode: '',
        country: '',
        address_type: '',
        phone_number: '',
        fax_number: '',
        fedral_tax_id: ''
      },
      isEmployeeFormValid: true,
      employeeformStatus: '',
      employeeFormData: {
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        business_employee_type: 'Employee',
        billing_address: '',
        address_line_2: '',
        city: '',
        state: '',
        zipcode: '',
        country: ''
      }
    };
  },


  methods: {
    _initCustomMethods: function _initCustomMethods() {
      app._mobileOnlySlider();
      // custom JS code
      // eslint-disable-next-line
      if (app.storeUtilities.loginHelper.customerEmail == '') {
        setTimeout(function () {
          $('[data-login-form] [data-login-register]').addClass('disabled');
          if ($('#AddressCountryNew_pro').length > 0) {
            new Shopify.CountryProvinceSelector('AddressCountryNew_pro', 'AddressProvinceNew_pro', {
              hideElement: 'AddressProvinceContainerNew_pro'
            });
          }
        }, 500);
      }

      setTimeout(function () {
        var rte = $('#description .rte').html();
        var style = $('.product-description .download-link').html();
        // eslint-disable-next-line eqeqeq
        if ($.trim(rte) == '' && $.trim(style) == '') {
          $('.product-description').hide();
        }
      }, 1000);

      var $klaviyoForm = $('[data-formsubmit]').closest('form');
      var success_msg = $klaviyoForm.find('[data-subscribe-success]');
      var subscribed_msg = $klaviyoForm.attr('data-subscribedmsg');
      KlaviyoSubscribe.attachToForms('#email_subscribe', {
        hide_form_on_success: false,
        custom_success_message: true,
        success: function success(response) {
          success_msg.html(subscribed_msg).css('opacity', '1').show();
          setTimeout(function () {
            success_msg.css('opacity', '0').hide();
          }, 3000);
        }
      });

      $('body').on('click', '[data-subscribeFormButton]', function (event) {
        event.preventDefault();
        var error_msg = $('#email_subscribe').find('[data-subscribe-error]');

        if ($('#k_id_email').val() != '' && $('#k_id_email').val() != null) {
          if ($("#id_member_field_country_footer").val() != "" && $("#id_member_field_i-am-a_footer").val() != "" && $("#id_member_field_country_footer").val() != null && $("#id_member_field_i-am-a_footer").val() != null) {
            $('[data-formSubmit]').click();
          } else {
            error_msg.html('Please select an option').fadeIn('slow').delay(3000).fadeOut('slow');
          }
        } else {
          error_msg.html('Please enter valid email').fadeIn('slow').delay(3000).fadeOut('slow');
        }
      });

      $('[data-subscribe]').on('click', function (e) {
        e.preventDefault();
        var $newsletterPopup = $(app.selectors.newsletterPopup);
        var daysUntil = $newsletterPopup.data('period-until');
        var newsletterPopupEnabled = $newsletterPopup.data('newsletter-enabled');
        var newsletterPopupStatus = app._getCookie('newsletter_popup_status');
        var today = new Date();
        var expirationDate = new Date();
        expirationDate.setDate(today.getDate() + daysUntil);
        var time = expirationDate.getTime();
        var expireTime = time + 1000 * 36000;
        expirationDate.setTime(expireTime);
        var $this = $(this);

        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // eslint-disable-next-line eqeqeq
        if ($this.closest('form').find('[name=email]').val() != '') {
          if ($this.closest('form').find('[name=email]').val().match(re)) {
            app.isProMailValid = true;
            $this.closest('form').find('.mail_error').removeClass('error');

            axios.post('https://code.wolfpointagency.com/migration/yalelock/subscriberRegistration.php', {
              data: $this.closest('form').serializeArray()
            }).then(function (response) {
              var cookie = app._getCookie('newsletter_popup_status');
              // eslint-disable-next-line eqeqeq
              // eslint-disable-next-line promise/always-return
              if (cookie !== 'disabled') {
                app._toggleNewsletterPopup();
                document.cookie = 'newsletter_popup_status=disabled;expires=' + expirationDate.toGMTString() + ';path=/';
              }
              $this.closest('form').find('.success').html('Thank you. For registration!');
              setTimeout(function () {
                $this.closest('form').find('.success').fadeOut();
              }, 2000);
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            app.isProMailValid = false;
            $this.closest('form').find('.mail_error').html('Please enter a valid email.').addClass('error');
            return false;
          }
        } else {
          app.isProMailValid = false;
          $this.closest('form').find('.mail_error').html('Please enter an email id.').addClass('error');
          return false;
        }
      });

      $('[data-sign-up]').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);

        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // eslint-disable-next-line eqeqeq
        if ($this.closest('form').find('[name="email"]').val() != '' && $this.closest('form').find('[name="member_field_pets-ownership"]:checked').val() != null && $this.closest('form').find('[name="member_field_first_name"]').val() != '' && $this.closest('form').find('[name="member_field_zip-code"]').val() != '' && $this.closest('form').find('[name="member_field_last_name"]').val() != '') {
          if ($this.closest('form').find('[name="email"]').val().match(re)) {
            if ($('[name="customer_logged_in"]').is(':checked')) {
              $this.closest('form').find('.mail_error').removeClass('error');
              axios.post('https://code.wolfpointagency.com/migration/yalelock/signup.php', {
                data: $this.closest('form').serializeArray()
              }).then(function (response) {
                $this.closest('form').find('.success').html('Thank you! Your information has been submitted. A confirmation email is on its way to <b>' + $this.closest('form').find('[name="email"]').val() + '</b> and should arrive shortly.');
                setTimeout(function () {
                  $this.closest('form').find('.success').fadeOut();
                }, 4000);
              }).catch(function (error) {
                console.log(error);
              });
            } else {
              $this.closest('form').find('.mail_error').html('Please check tems and condition.').addClass('error');
              return false;
            }
          } else {
            $this.closest('form').find('.mail_error').html('Please enter a valid email.').addClass('error');
            return false;
          }
        } else {
          $this.closest('form').find('.mail_error').html('Please fill all the required fields.').addClass('error');
          return false;
        }
      });

      $('[data-notify-me]').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);

        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // eslint-disable-next-line eqeqeq
        if ($this.closest('form').find('[name="email"]').val() != '' && $this.closest('form').find('[name="member_field_first_name"]').val() != '' && $this.closest('form').find('[name="member_field_zip-code"]').val() != '' && $this.closest('form').find('[name="member_field_state"]').val() != '') {
          if ($this.closest('form').find('[name="email"]').val().match(re)) {
            $this.closest('form').find('.mail_error').removeClass('error');
            axios.post('https://code.wolfpointagency.com/migration/yalelock/notify-me.php', {
              data: $this.closest('form').serializeArray()
            }).then(function (response) {
              $('[data-notifyme]').hide();
              $('[data-thankyou]').show();
              $('html, body').animate({
                scrollTop: $('#shopify-section-header').offset().top
              }, 1000);
              // $this.closest('form').find('.success').html('Thank you! Your information has been submitted. A confirmation email is on its way to <b>'+ $this.closest('form').find('[name="email"]').val() +'</b> and should arrive shortly.');
              // setTimeout(() => {
              //   $this.closest('form').find('.success').fadeOut();
              // }, 4000);
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            $this.closest('form').find('.mail_error').html('Please enter a valid email.').addClass('error');
            return false;
          }
        } else {
          $this.closest('form').find('.mail_error').html('Please fill all the required fields.').addClass('error');
          return false;
        }
      });

      $('.delivery-box-option input[type="radio"]').change(function () {
        var data_image = $(this).attr('data-image');
        console.log(data_image);
        $(this).parents('.delivery-box-option').siblings('img.product_img').attr('src', data_image);
      });

      $('[data-product-grid]').each(function () {
        var price = $(this).find('.product-price').data('price');
        var discount = $(this).data('discount');
        var calcPerc = 0;
        // eslint-disable-next-line eqeqeq
        if (discount != 'no') {
          calcPerc = price / 100 * discount;
        }
        calcPerc = calcPerc.toFixed();
        // eslint-disable-next-line eqeqeq
        if (calcPerc == 0) {
          $(this).find('[data-discount-price]').text(app._formatMoney(price));
        } else {
          $(this).find('[data-discount-price]').text(app._formatMoney(calcPerc));
        }
      });

      setTimeout(function () {
        $('.collection-filters .card .list-unstyled').each(function () {
          // eslint-disable-next-line eqeqeq
          if ($(this).find('.active').length != 0) {
            $(this).closest('.card').find('.card-body').addClass('show');
            $(this).closest('.card').find('.card-header').removeClass('collapsed').attr('aria-expanded', true);
          }
        });
      }, 1000);

      $('#AddressCountryNew_pro').on('change', function () {
        var target = $(event.currentTarget).val();
        setTimeout(function () {
          // eslint-disable-next-line eqeqeq
          if ($('#AddressProvinceNew_pro option').length == 0) {
            $('#AddressProvinceNew_pro').removeClass('required');
          }
          // eslint-disable-next-line eqeqeq
          if (target != 'United States') {
            app.yaleProformStatus = '';
            app.isYaleProFormValid = true;
          } else {
            var value = $('[data-business_type]').val();
            var state = $('#AddressProvinceNew_pro').val();
            console.log(value, state);
            // eslint-disable-next-line eqeqeq
            if (value == 'Locksmith') {
              // eslint-disable-next-line eqeqeq
              if (state == 'Connecticut' || state == 'New York' || state == 'New Jersey' || state == 'Massachusetts' || state == 'Rhode Island' || state == 'Minnesota' || state == 'Virginia' || state == 'Pennsylvania') {
                app.yaleProformStatus = 'Please visit our distribution partners in your area.  - <a class="border-bottom custom-border text-black" href="http://www.standardlock.com/default.aspx?pageid=1">Standard</a> and <a class="border-bottom custom-border text-black" href="http://www.acclock.com/">Accredidated</a>';
                app.isYaleProFormValid = false;
              } else {
                app.yaleProformStatus = '';
                app.isYaleProFormValid = true;
              }
            }
          }
        }, 800);
      });

      app._scriptCustomreForm();

      setTimeout(function () {
        if ($('#instagram-popup-variant-template').find('.instagram-shop-detail-product-image').length) {
          $('#instagram-popup-variant-template').find('.instagram-shop-detail-product-image').attr('alt', 'Instagram shop detail product');
        }
        if ($('#instagram-popup-tag-template').find('.instagram-shop-detail-product-image').length) {
          $('#instagram-popup-tag-template').find('.instagram-shop-detail-product-image').attr('alt', 'Instagram product');
        }
        if ($('.instagram-shop-wide-timeline, .instagram-shop-narrow-timeline').find('.instagram-shop-detail-image').length) {
          $('.instagram-shop-wide-timeline, .instagram-shop-narrow-timeline').find('.instagram-shop-detail-image').attr('alt', 'Instagram');
        }
        if ($('.vjs-menu').length) {
          $('.vjs-menu').find('ul').removeAttr('role');
        }
      }, 2000);
    },
    _mobileOnlySlider: function _mobileOnlySlider() {
      var relatedProSlider = $('[data-mobileonly-slider]').length;
      if (relatedProSlider > 0) {
        if (matchMedia('screen and (max-width: 767px)').matches) {
          var $carousel1 = $('[data-mobileonly-slider]');
          var $carousel2 = $('[data-mobileonly-slider02]');
          var $carousel3 = $('[data-mobileonly-slider03]');
          var $carousel4 = $('[data-mobileonly-slider04]');
          var options1 = {
            adaptiveHeight: true,
            contain: true,
            wrapAround: false,
            freeScroll: false,
            accessibility: true,
            setGallerySize: true,
            prevNextButtons: true,
            pageDots: false,
            groupCells: '100%',
            draggable: true,
            dragThreshold: 20,
            arrowShape: {
              "x0": 10,
              "x1": 60,
              "y1": 50,
              "x2": 60,
              "y2": 45,
              "x3": 15
            }
          };
          var flkty1 = new Flickity($carousel1[0], options1);
          var flkty2 = new Flickity($carousel2[0], options1);
          var flkty3 = new Flickity($carousel3[0], options1);
          var flkty4 = new Flickity($carousel4[0], options1);
        }
      }
    },
    _emailValidate: function _emailValidate(event) {
      var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
      var mailValue = $.trim($(event.currentTarget).val());
      if (testEmail.test(mailValue)) {
        if ($(event.currentTarget).closest('[data-register-form]').length > 0) {
          if (app.ispassWordMatched) {
            $(event.currentTarget).closest('form').find('[data-login-register]').removeClass('disabled');
          }
        } else {
          $(event.currentTarget).closest('form').find('[data-login-register]').removeClass('disabled');
        }
      } else {
        $(event.currentTarget).closest('form').find('[data-login-register]').addClass('disabled');
      }
    },
    _donationAmountChange: function _donationAmountChange(event) {
      var inputValue = $(event.currentTarget).val();
      inputValue = $.trim(inputValue.replace(/[^0-9\.]/g, ''));
      $(event.currentTarget).val(inputValue);
      // eslint-disable-next-line max-statements-per-line
      if (inputValue < 5 || inputValue > 25) {
        app.isDonationAvailable = false;
      } else {
        app.isDonationAvailable = true;
      }
    },
    _storeDonationAmount: function _storeDonationAmount() {
      var donationproduct = $(app.selectors.donationProduct).html();
      // eslint-disable-next-line eqeqeq
      if (donationproduct == '') {
        return false;
      }
      donationproduct = JSON.parse(donationproduct);
      var donationAmount = $.trim($('[data-donationAmount]').val());
      var donationId = donationproduct.variants[donationAmount - 5].id;
      app._manageDonationProduct(donationproduct.product, donationId);
    },
    _manageDonationProduct: function _manageDonationProduct(mainProId, variantId) {
      var itemIndex = void 0;
      app.isLoadingMethods = 'addingDonation';
      $(app.cart.items).each(function (index, value) {
        // eslint-disable-next-line eqeqeq
        if (value.product_id == mainProId) {
          itemIndex = index + 1;
        }
      });

      // eslint-disable-next-line eqeqeq
      if (itemIndex != undefined) {
        axios.post('/cart/change.js', {
          quantity: 0,
          line: itemIndex
        })
        // eslint-disable-next-line promise/always-return
        .then(function () {
          setTimeout(function () {
            app._addDonationProduct(variantId);
          }, 1000);
        }).catch(function (error) {
          app.isLoading = false;
          app.isLoadingMethods = '';
          app._getCartData();
          app.$snotify.error('Oops!', 'Erorr occured. Please Try again.', {
            timeout: 6000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            buttons: [{
              text: 'Close',
              bold: true,
              closeOnClick: true
            }]
          });
          throw error;
        });
      } else {
        app._addDonationProduct(variantId);
      }
    },
    _addDonationProduct: function _addDonationProduct(variantId) {
      axios.post('/cart/add.js', {
        quantity: 1,
        id: variantId,
        properties: { product_type: 'donation' }
      })
      // eslint-disable-next-line promise/always-return
      .then(function () {
        app.isLoading = false;
        app.isLoadingMethods = '';
        app._getCartData();
        $('[data-donationAmount]').val('');
        app.isDonationAvailable = false;
        app.$snotify.success('Donation Added.', 'Success!', {
          timeout: 6000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      }).catch(function (error) {
        // alert('Fail')
        console.log('Fail', error);
        throw error;
      });
    },
    _scriptCustomreForm: function _scriptCustomreForm(event) {
      $('[data-business_type]').on('change', function (event) {
        var value = $(event.currentTarget).val();
        var state = $('#AddressProvinceNew_pro').val();
        // eslint-disable-next-line eqeqeq
        if (value == 'Locksmith') {
          // eslint-disable-next-line eqeqeq
          if (state == 'Connecticut' || state == 'New York' || state == 'New Jersey' || state == 'Massachusetts' || state == 'Rhode Island' || state == 'Minnesota' || state == 'Virginia' || state == 'Pennsylvania') {
            app.yaleProformStatus = 'Please visit our distribution partners in your area.  - <a class="border-bottom custom-border text-black" href="http://www.standardlock.com/default.aspx?pageid=1">Standard</a> and <a class="border-bottom custom-border text-black" href="http://www.acclock.com/">Accredidated</a>';
            app.isYaleProFormValid = false;
          } else {
            app.yaleProformStatus = '';
            app.isYaleProFormValid = true;
          }
        } else {
          app.yaleProformStatus = '';
          app.isYaleProFormValid = true;
        }
      });
      $('#AddressProvinceNew_pro').on('change', function (event) {
        var state = $(event.currentTarget).val();
        var value = $('[data-business_type]').val();
        // eslint-disable-next-line eqeqeq
        if (state == 'Connecticut' || state == 'New York' || state == 'New Jersey' || state == 'Massachusetts' || state == 'Rhode Island' || state == 'Minnesota' || state == 'Virginia' || state == 'Pennsylvania') {
          // eslint-disable-next-line eqeqeq
          if (value == 'Locksmith') {
            app.yaleProformStatus = 'Please visit our distribution partners in your area.  - <a class="border-bottom custom-border text-black" href="http://www.standardlock.com/default.aspx?pageid=1">Standard</a> and <a class="border-bottom custom-border text-black" href="http://www.acclock.com/">Accredidated</a>';
            app.isYaleProFormValid = false;
          } else {
            app.yaleProformStatus = '';
            app.isYaleProFormValid = true;
          }
        } else {
          app.yaleProformStatus = '';
          app.isYaleProFormValid = true;
        }
      });
    },
    _yaleCustomreForm: function _yaleCustomreForm(event) {
      var $targetForm = $(event.currentTarget).closest('form');
      var approvedElement = 0;
      // eslint-disable-next-line radix
      var countWords = parseInt($('[data-tax_id] input').val().length);
      var totalElemensts = $targetForm.find('.required').length;
      $targetForm.find('.required').each(function () {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var targetEle = $(this);
        var eleValue = $.trim(targetEle.val());
        if (eleValue.length <= 0) {
          targetEle.addClass('error');
        } else {
          targetEle.removeClass('error');
          approvedElement += 1;
        }
      });
      // eslint-disable-next-line eqeqeq
      if (approvedElement == totalElemensts) {
        // eslint-disable-next-line eqeqeq
        if ($('#AddressCountryNew_pro').val() == 'United States') {
          if (countWords > 0 && countWords < 9) {
            app.yaleProformStatus = 'Please submit a valid tax ID number.';
            app.isYaleProFormValid = false;
          } else {
            app._yaleFormSubmitEvent($targetForm);
          }
        } else {
          app.yaleProformStatus = 'This program is only available in the U.S. at this time.';
          app.isYaleProFormValid = false;
        }
      } else {
        app.yaleProformStatus = 'Provide all required details.';
        app.isYaleProFormValid = false;
      }
    },
    _yaleFormSubmitEvent: function _yaleFormSubmitEvent(form) {
      axios({
        method: form.attr('method'),
        url: form.attr('action'),
        data: form.serializeArray()
      }).then(function (response) {
        console.log();
        // eslint-disable-next-line promise/always-return
        if (response.data.error) {
          var json = $.parseJSON(response.data.error);
          if (json.email) {
            app.yaleProformStatus = 'Email ' + json.email + '. Try Again.';
            app.isYaleProFormValid = false;
            return false;
          }
          if (json.phone) {
            app.yaleProformStatus = 'Phone number ' + json.phone + '. Try Again.';
            app.isYaleProFormValid = false;
            return false;
          }
        } else {
          axios({
            method: $('[data-proRegisterWithEmma]').attr('method'),
            url: $('[data-proRegisterWithEmma]').attr('action'),
            data: $('[data-proRegisterWithEmma]').serializeArray()
          }).then(function (response) {
            console.log(response);
          }).catch(function (error) {
            console.log(error);
          });
          app.yaleProformStatus = 'Thank you! The form was submitted successfully.';
          app.isYaleProFormValid = false;
        }
      }).catch(function () {
        app.yaleProformStatus = 'Oops! Form Submission failed. Try Again.';
        app.isYaleProFormValid = false;
      });
    },
    _yaleEmployeeForm: function _yaleEmployeeForm(event) {
      var $targetForm = $(event.currentTarget).closest('form');
      var approvedElement = 0;
      var totalElemensts = $targetForm.find('.required').length;
      $targetForm.find('.required').each(function () {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var targetEle = $(this);
        var eleValue = $.trim(targetEle.val());
        if (eleValue.length <= 0) {
          targetEle.addClass('error');
        } else {
          targetEle.removeClass('error');
          approvedElement += 1;
        }
      });
      // eslint-disable-next-line eqeqeq
      if (approvedElement == totalElemensts) {
        app._employeeFormSubmitEvent($targetForm);
      } else {
        app.employeeformStatus = 'Provide all required details.';
        app.isEmployeeFormValid = false;
      }
    },
    _employeeFormSubmitEvent: function _employeeFormSubmitEvent(form) {
      axios({
        method: form.attr('method'),
        url: form.attr('action'),
        data: form.serializeArray()
      }).then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.error) {
          var json = $.parseJSON(response.data.error);
          if (json.email) {
            app.employeeformStatus = 'Email ' + json.email + '. Try Again.';
            app.isEmployeeFormValid = false;
            return false;
          }
          if (json.phone) {
            app.employeeformStatus = 'Phone number ' + json.phone + '. Try Again.';
            app.isEmployeeFormValid = false;
            return false;
          }
        } else {
          axios({
            method: $('[data-proRegisterWithEmma]').attr('method'),
            url: $('[data-proRegisterWithEmma]').attr('action'),
            data: $('[data-proRegisterWithEmma]').serializeArray()
          }).then(function (response) {
            console.log(response);
          }).catch(function (error) {
            console.log(error);
          });
          app.employeeformStatus = 'Thank you! The form was submitted successfully.';
          app.isEmployeeFormValid = false;
        }
      }).catch(function () {
        app.employeeformStatus = 'Oops! Form Submission failed. Try Again.';
        app.isEmployeeFormValid = false;
      });
    },
    _gotoFunction: function _gotoFunction(event, current, next, data) {
      $('[data-step-' + current + ']').addClass('hide-div');
      $('[data-step-' + next + ']').removeClass('hide-div');
      if (data !== '') {
        app.allLog.push(data);
        if (app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('one') > -1 && app.allLog.indexOf('closet') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('one') > -1 && app.allLog.indexOf('bathroom') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('one') > -1 && app.allLog.indexOf('bedroom') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('one') > -1 && app.allLog.indexOf('home-office') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('one') > -1 && app.allLog.indexOf('baseroom') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('two') > -1 && app.allLog.indexOf('closet') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('two') > -1 && app.allLog.indexOf('bathroom') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('two') > -1 && app.allLog.indexOf('bedroom') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('two') > -1 && app.allLog.indexOf('home-office') > -1 || app.allLog.indexOf('interior') > -1 && app.allLog.indexOf('two') > -1 && app.allLog.indexOf('baseroom') > -1) {
          app._exitFunction(event, current, 13);
          $('[data-step-' + next + ']').addClass('hide-div');
        } else if (app.allLog.indexOf('notsmartlock') > -1) {
          app.answerLog.pop();
          app.allLog.pop();
        } else if (app.setTimeOne) {
          if (app.allLog.indexOf('exterior') > -1 && app.allLog.indexOf('one') > -1 || app.allLog.indexOf('exterior') > -1 && app.allLog.indexOf('two') > -1) {
            app._gotoFunction(event, current, 5, '');
            $('[data-step-4]').addClass('hide-div');
            app.setTimeOne = false;
          }
        } else if (next === 13) {
          app._exitFunction(event, current, 13);
        }
        $(app.selectors.productObj).each(function (index, mainitem) {
          var productData = JSON.parse($(mainitem).html());
          var product = productData.product;
          var optionsWithValues = productData.options_with_values;
          product.current_variant = product.variants[0];
          // eslint-disable-next-line no-empty
          $(product).each(function (index, subitem) {
            $(subitem.tags).each(function (index, tag) {
              if (tag.indexOf(data + '_') > -1) {
                if (tag === data + '_yes') {
                  // Remove duplicate URL tags
                  app.answerLog.push(tag);
                  var newarray = app.answerLog.filter(function (elem, index, self) {
                    return index === self.indexOf(elem);
                  });
                  app.answerLog = newarray;
                } else {
                  app.resultLog.push(tag);
                }
              }
            });
          });
        });
      }
    },
    _skipFunction: function _skipFunction(event, current, next) {
      $('[data-step-' + current + ']').addClass('hide-div');
      $('[data-step-' + next + ']').removeClass('hide-div');
      app.answerLog.push('null');
    },
    _back: function _back(event, current, prev) {
      $('[data-step-' + current + ']').addClass('hide-div');
      $('[data-step-' + prev + ']').removeClass('hide-div');
      $('[data-step-' + prev + ']').find('input').prop('checked', false);
    },
    _gobackFunction: function _gobackFunction(event, current, prev) {
      if (app.setTimeOneBack) {
        if (app.allLog.indexOf('exterior') > -1 && app.allLog.indexOf('one') > -1 || app.allLog.indexOf('exterior') > -1 && app.allLog.indexOf('two') > -1) {
          if (current === 5) {
            app._back(event, current, 3);
            app.setTimeOne = true;
          } else {
            app._back(event, current, prev);
          }
        } else {
          app._back(event, current, prev);
        }
      } else {
        app._back(event, current, prev);
      }
      // eslint-disable-next-line eqeqeq
      if (prev == 2) {
        app.setTimeOneBack = true;
        app.setTimeOne = true;
      }
      app.answerLog.pop();
      app.allLog.pop();
    },
    _exitFunction: function _exitFunction(event, current, next) {
      $('[data-step-' + current + ']').addClass('hide-div');
      $('[data-step-' + next + ']').removeClass('hide-div');
      app._pageInit();
      setTimeout(function () {
        app._setProductCardReviews();
      }, 1000);
    },
    _specificFunction: function _specificFunction(event, current, next, specific) {
      $('[data-step-' + current + ']').addClass('hide-div');
      $('[data-step-' + next + ']').removeClass('hide-div');
      app.answerLog = [];
      app.questions.answer3 = 'Key & Keypad';
      app.answerLog.push(specific + '_yes');
      app._pageInit();
      setTimeout(function () {
        app._setProductCardReviews();
      }, 1000);
    },
    _pageInit: function _pageInit() {
      var data = '';
      // eslint-disable-next-line eqeqeq
      if ($('body').attr('id') == 'product-selector') {

        app.isLoadingResult = true;
        app.answerLog.forEach(function (itemX, index) {
          if (itemX !== 'null') {
            if (index !== 0) {
              data += '+' + itemX;
            } else {
              data += '' + itemX;
            }
          }
        });

        app.productSelectorURL = '/collections/product-selector?constraint=' + data;

        if (data !== '') {
          // Call for result ( used the SAMPLE collection )
          axios.get('/collections/sample?constraint=' + data, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          // eslint-disable-next-line promise/always-return
          .then(function (response) {
            app.page = [];
            app.isLoadingResult = false;
            response.data.products.forEach(function (product, index) {
              if (index < 12) {
                // collection list
                product.product.collection = '-';
                // categorize unique variant display
                product.options_with_values[0].display = [];
                // related tags
                product.options_with_values.forEach(function (value, index) {
                  // eslint-disable-next-line eqeqeq
                  if (product.options_with_values[index].name == 'Finish') {
                    product.options_with_values[index].values.forEach(function (value) {
                      app.resultLog.forEach(function (tag) {
                        var val = app._handleize(value);
                        if (tag.indexOf(product.product.handle + '_' + val) > -1) {
                          product.options_with_values[0].display.push(val);
                        }
                        product.product.tags.forEach(function (tag) {
                          if (tag.match('collection-')) {
                            var collection = tag.replace('collection-', '').replace('_', ' ').replace('_', ' ');
                            product.product.collection = collection;
                          }
                        });

                        // Remove duplicate finish title
                        if (product.options_with_values[0].display.length > 0) {
                          var myNewArray = product.options_with_values[0].display.filter(function (elem, index, self) {
                            return index === self.indexOf(elem);
                          });
                          product.options_with_values[0].display = myNewArray;
                        }
                      });
                    });
                  }
                });
                // Display products
                app.page.push(product);
                // change variant
                app.collection.products.push(product.product);
              }
            });
            // selected first variant
            setTimeout(function () {
              $('[data-product-form] [data-color-checked]').each(function () {
                $(this).find('label:last').trigger('click');
              });
            }, 300);
          }).catch(function (error) {
            throw error;
          });
        }
      }
    }
  }
};

export default customMethods;